package ai.wagemix.data

import co.touchlab.kermit.Severity
import com.fsryan.foundation.util.log.FSLog
import com.fsryan.foundation.util.log.sendEventInclusive

/*
 * Every structured event the data layer emits (structured-logging playbook). Keys are literal
 * snake_case; failures travel as the throwable.
 */

internal fun FSLog.sendWMSyncFailure(operation: String, scope: String, sequenceId: String, error: Throwable) {
    sendEventInclusive(throwable = error, severity = Severity.Warn, eventName = "WMSyncFailure") {
        put("operation", operation)
        put("scope", scope)
        put("sequence_id", sequenceId)
    }
}

internal fun FSLog.sendWMCacheDeserializeFailure(key: String, slice: String, storedVersion: Int, error: Throwable) {
    sendEventInclusive(throwable = error, severity = Severity.Error, eventName = "WMCacheDeserializeFailure") {
        put("cache_key", key)
        put("slice", slice)
        put("stored_version", storedVersion)
    }
}
